/**
 * Specifies plurals used for translations
 */
export const i18nPlurals = {
  brands: {
    '0': Symbol(),
    '1': Symbol(),
    '2': Symbol(),
  }
};

/**
 * Collects all i18n keys for easy and safe access throughout the app. Then once a language is loaded
 * (via {@link I18nService}) the actual texts can be accessed using these same keys.
 */
export const i18n = {
  generic: {
    authorizedBy: Symbol(),
    brands: Symbol()
  },
  alt: {
    authorizedBySeal: Symbol(),
    tuvSeal: Symbol()
  },
  menu: {
    checkAuthorizations: {
      caption: Symbol()
    },
    imprint: {
      caption: Symbol(),
      link: Symbol()
    },
    privacyPolicy: {
      caption: Symbol(),
      link: Symbol()
    }
  },
  header: {
    texts: {
      brandLink: {
        multiple: Symbol(),
        two: Symbol(),
        one: Symbol(),
      },
      full: {
        isAuthorized1: Symbol(),
        isAuthorized2: Symbol(),
        isAuthorized2_t0NotApproved: Symbol(),
        isAuthorized2_t0NoBrands: Symbol(),
        isAuthorized3: Symbol(),
        brands: Symbol()
      }
    }
  },
  contents: {
    texts: {
      lastVerified: Symbol(),
      lastVerified_t0NotApproved: Symbol(),
      lastVerified_t0NoBrands: Symbol(),
      tuvMember: Symbol(),
      t0Message: Symbol(),

      shopCheckTitle: Symbol(),
      shopCheckText: Symbol(),
      originalityConfirmedTitle: Symbol(),
      originalityConfirmedText: Symbol(),
      authRetailerTitle: Symbol(),
      authRetailerText: Symbol(),

      shopCheckTitle_brandSponsored: Symbol(),
      shopCheckText_brandSponsored: Symbol(),

      shopCheckTitle_d2c: Symbol(),
      shopCheckTitle_noTuv_d2c: Symbol(),
      shopCheckText_d2c: Symbol(),
      shopCheckText_noTuv_d2c: Symbol(),
      originalityConfirmedTitle_d2c: Symbol(),
      originalityConfirmedText_d2c: Symbol(),
      authRetailerTitle_d2c: Symbol(),
      authRetailerText_d2c: Symbol(),
    }
  },
  footer: {
    showCertificate: Symbol()
  }
};
